// Polis dans la nouvelle interface, épurée (10 octobre 2026) : l'onglet « Le
// scrutin » (`components/epure/polis/EPolisScrutin.vue`). Ses règles, son
// calendrier, la campagne que lisent les jumeaux, les listes par bloc, la
// relance de la préparation et la modification des listes.
export default {
  chargement: 'Chargement…',
  erreur: {
    lecture: 'Lecture impossible',
    reessayer: 'Réessayer',
    fermer: 'fermer',
  },
  actions: {
    relancer: 'Relancer la préparation',
    modifierListes: 'Modifier les listes',
    modifierCandidats: 'Modifier les candidats',
  },
  regles: {
    titre: 'Les règles',
  },
  calendrier: {
    titre: 'Le calendrier',
    aujourdhui: 'Aujourd’hui',
    jourDuVote: 'Le scrutin',
    compte: {
      aujourdhui: 'aujourd’hui',
      demain: 'demain',
      dans: 'dans {n} jours',
      passe: 'passé',
    },
  },
  campagne: {
    titre: 'La campagne, au {date}',
    titreSansDate: 'La campagne',
    source: 'rédigée par Orion à partir de sources publiques, sans aucun sondage',
    lireTout: 'Lire toute la campagne',
    replier: 'Replier la campagne',
    recomposition: 'Ce que sont devenus les partis de l’élection précédente | Ce qu’est devenu le parti de l’élection précédente | Ce que sont devenus les {n} partis de l’élection précédente',
  },
  listes: {
    titreListes: 'Aucune liste | La liste | Les {n} listes',
    titreCandidats: 'Aucun candidat | Le candidat | Les {n} candidats',
    aide: 'un clic ouvre la fiche de campagne que lisent les jumeaux',
    horsBlocs: 'Hors des blocs',
    aucuneListe: 'Aucune liste pour cette élection.',
    aucunCandidat: 'Aucun candidat pour cette élection.',
  },
  relance: {
    titre: 'Relancer la préparation',
    aide: 'Orion se renseigne de nouveau sur cette élection : les listes ou les candidats, leurs fiches, l’état de la campagne.',
    consignes: 'Ce que vous voulez projeter',
    placeholder: 'Un candidat par camp ; ou une hypothèse : tel candidat se présente, tel autre non',
    lancer: 'Orion se renseigne de nouveau',
    annuler: 'Annuler',
  },
  edition: {
    titreListes: 'Modifier les listes',
    inscrits: 'Inscrits sur les listes',
    inscritsExemple: '50 187 093',
    blancsNuls: 'Blancs et nuls, en % des votants',
    titreCandidats: 'Modifier les candidats',
    aide: 'Ce que lisent les jumeaux avant de voter : les fiches et l’état de la campagne.',
    nouvelleListe: 'Nouvelle liste',
    nouveauCandidat: 'Nouveau candidat',
    supprimerListe: 'Supprimer la liste {nom}',
    supprimerCandidat: 'Retirer le candidat {nom}',
    nom: 'Nom',
    teteDeListe: 'Tête de liste',
    partiOuSoutien: 'Parti ou soutien',
    bloc: 'Bloc',
    fiche: 'En une phrase',
    fichePlaceholder: 'Qui, et où il se situe, en une phrase',
    ficheCampagne: 'Fiche de campagne',
    ficheCampagnePlaceholder: 'Sa campagne : qui le soutient, ses positions, ses alliances, un temps fort récent',
    ajouterListe: 'Ajouter une liste',
    ajouterCandidat: 'Ajouter un candidat',
    campagne: 'L’état de la campagne',
    auMoinsDeuxListes: 'Au moins deux listes nommées pour enregistrer.',
    auMoinsDeuxCandidats: 'Au moins deux candidats nommés pour enregistrer.',
    annuler: 'Annuler',
    enregistrer: 'Enregistrer',
  },
}
